// extracted by mini-css-extract-plugin
export default {"chartsSection":"ChartsSection_chartsSection__zuPsx","sectionTitle":"ChartsSection_sectionTitle__vp2Tp","chartsGrid":"ChartsSection_chartsGrid__eci8A"};